// extracted by mini-css-extract-plugin
export var blue = "_1a-g";
export var brand = "_1a-c";
export var darkGrey = "_1a-f";
export var disabled = "_1a-6";
export var disabledSubtle = "_1a-7";
export var error = "_1a-8";
export var green = "_1a-h";
export var grey = "_1a-e";
export var icon = "_1a-0";
export var inherit = "_1a-b";
export var lightGrey = "_1a-d";
export var orange = "_1a-j";
export var pink = "_1a-l";
export var primary = "_1a-1";
export var purple = "_1a-m";
export var quaternary = "_1a-4";
export var quinary = "_1a-5";
export var red = "_1a-k";
export var secondary = "_1a-2";
export var success = "_1a-a";
export var tertiary = "_1a-3";
export var warning = "_1a-9";
export var white = "_1a-n";
export var yellow = "_1a-i";